import { motion, useAnimation, useInView } from "framer-motion";
import { CtaUnderline } from "../../../../assets/svgComponents/CtaUnderline";
import { CardForm } from "./CardForm";
import Container from "../Container";
import { useEffect, useRef } from "react";

export const CTASection = () => {
  const ref = useRef(null);

  const isInView = useInView(ref, { once: true, amount: 0.1 });

  const controls = useAnimation();

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [isInView, controls]);

  return (
    <div ref={ref}>
      <Container
        animationControls={controls}
        ellipseClasses="!top-0"
        sectionClasses=" max-lg:mt-[2vw] relative max-lg:pb-[27vw] pb-[4vw]"
      >
        <section className="px-[2.78vw] max-lg:px-0  max-lg:pb-[24vw]">
          <div className="lg:max-w-[90vw] max-lg:w-full mx-auto text-center">
            <motion.div
              className="mb-[2.78vw] max-lg:mb-[5vw]"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <motion.h2 className="text-[4.44vw] max-lg:text-[8.53vw] font-luxora-regular leading-[110%] relative ">
                <motion.span
                  className="z-10 relative"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  Join Waitlist to get your
                </motion.span>
                <CtaUnderline
                  className="absolute bottom-[-5%] left-[36%] max-lg:left-[26%] -translate-x-1/2 z-[0] pointer-events-none
                        w-[26.25vw] max-lg:w-[50.8vw] lg:h-[2.50vw] "
                />{" "}
              </motion.h2>

              <motion.div
                className="text-[4.44vw] max-lg:text-[8.53vw] font-luxora-regular  leading-[110%] text-black mt-[1.39vw] max-lg:mt-0"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ delay: 0.8, duration: 0.6 }}
              >
                AGNT Neo3 Card first
              </motion.div>
            </motion.div>

            <CardForm />
          </div>
        </section>
      </Container>
    </div>
  );
};
